import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, Grid, Hidden, IconButton, Skeleton, Theme, Tooltip, Typography, useTheme } from '@mui/material'
import CustomePieChart, { ChartListSkeletonLoader } from '../../dashboard/chart/CustomePieChart'
import CircleIcon from '@mui/icons-material/Circle';
import { useDispatch, useSelector } from 'react-redux';
import { DistributorType, filterType, GETOVERVIEW, MultipleChart, PortFolioExpore } from '../../../redux-store/types/api-types';
import CustomDropdown from '../../../lib/formik/CustomDropdown';
import { BlackDownloadIcon, BlackRightArrowIcons, BlueRightIcon, CircleDownloadIcon } from '../../../assets/SvgIcons';
import CustomTable from '../common/customTable';
import { Order, SortingObj, ColorMap } from '../types';
import { calculateOthersInPieChart, isRMLikeRole } from '../../../utils/utilityFunctions';
import { AmcTableBody, CategoryTableBody, AmctableHeaderData, tableHeaderData } from './common/Table';
import { Performance } from './common/PerFormance';
import { useHistory } from 'react-router';
import { RootStateType } from '../../../redux-store/reducers';
import { AMCPerformanceProductsRes, CategoryWiseDistibutionRes, PerformanceNavChartRes, PortfolioExposureMFRes, SebiAssetAllocationRes } from '../../../redux-store/types/products';
import { NO_DATA_AVAILABLE, USER_ROLES } from '../../../utils/constant';
import { amcPerformanceDownload, getCategoryWiseDistribution, getProductsAMCPerformance, getSebiAssetAllocation, performanceNavChart, portfolioExposureInCategory } from '../../../redux-store/actions/product';
import { ErrorText } from '../../dashboard/chart/CustomeLineChart';
import { reportDownload } from '../../Reports/report-utils';
import { getValueColor, formatCurrency, isFamilyView } from '../../../utils/utilityFunctions';
import { TableCell, TableRow } from '@mui/material';


const pieChartColor = ["#00A76F", "#FFAB00", "#3C92DC ", "#B8E8FC", "#FF563080", "#0D3C6B"]

interface OverviewProps {
    clientCode?: string;
    loading: boolean;
    urlPortfolio: string;
    maskedData?: boolean
}
const colorMap: ColorMap = {
    profit: "success.500",
    loss: "error.500"
}

function OverView(props: OverviewProps): JSX.Element {
    const { loading, urlPortfolio, maskedData } = props;
    const { palette } = useTheme()
    const dispatch = useDispatch()
    const [getAllData, setAllData] = useState<GETOVERVIEW>({} as GETOVERVIEW);
    const [isLoading, setIsloading] = useState<boolean>(false)
    const { iwappRmId, investorClientId, viewAsFamilyId = "" } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)
    const [categoryWiseLoading, setCategoryWiseLoading] = useState<boolean>(false)
    const [categoryWiseData, setCategoryWiseData] = useState<CategoryWiseDistibutionRes>({} as CategoryWiseDistibutionRes)
    const [amcPerformanceInvestorData, setAMCPerformanceInvestorData] = useState<AMCPerformanceProductsRes>({} as AMCPerformanceProductsRes)
    const [sebiAllocationData, setSebiAllocationData] = useState<SebiAssetAllocationRes>({} as SebiAssetAllocationRes)
    const history = useHistory();
    const { pathname: pathName, state } = history.location;
    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);
    const [sortingObj, setSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "investedValue" })
    const [amcSortingObj, setAMCSortingObj] = useState<SortingObj>({ order: "desc", orderBy: "investedValue" })
    const [amcLoader, setAmcLoader] = useState<boolean>(false)
    const [portfolioFilter, setPortfolioFilter] = useState<string | number>(1);
    const [portfolioLoader, setPortfolioLoader] = useState<boolean>(false)
    const [portfolioExposureData, setPortfolioExposureData] = useState<PortfolioExposureMFRes>({} as PortfolioExposureMFRes)
    const [performanceNavData, setPerformanceNavData] = useState<PerformanceNavChartRes>({} as PerformanceNavChartRes)
    const [performanceNavLoader, setPerformanceNavLoader] = useState<boolean>(false)
    const [amcDownloadLoader, setAmcDownloadLoader] = useState<boolean>(false)


    const clientCode = isRMLikeRole(role) ? props?.clientCode : isFamilyView(pathName) ? viewAsFamilyId : investorClientId;

    const categoryWiseInvestorLevel = async (orderBy = 'investedValue', order = 'desc') => {
        try {
            setCategoryWiseLoading(true);
            const productOverviewRes = await (dispatch(getCategoryWiseDistribution({
                rmId: `${investorRmId}`,
                sortItem: orderBy,
                order: order,
                clientCode: clientCode,
                // portfolioId: selectedPortfolio?.value,
                portfolioId: urlPortfolio,
                assetGroup: "MF"
            })) as unknown as Promise<CategoryWiseDistibutionRes>)
            setCategoryWiseData(productOverviewRes)
        } catch (e) {
            console.log("Error", e);
        } finally {
            setCategoryWiseLoading(false);
        }
    }

    const amcPerformanceInvestorLevel = async (orderBy = 'investedValue', order = 'desc') => {
        try {
            setAmcLoader(true);
            const amcPerformancePayload = {
                rmId: `${investorRmId}`,
                sortItem: orderBy,
                order: order,
                clientCode: clientCode,
                // portfolioId: selectedPortfolio?.value,
                portfolioId: urlPortfolio,
                assetGroup: "MF"
            }
            const amcPerformanceRes = await (dispatch(getProductsAMCPerformance(amcPerformancePayload)) as unknown as Promise<AMCPerformanceProductsRes>)
            setAMCPerformanceInvestorData(amcPerformanceRes)
        } catch (e) {
            console.log("Error", e);
        } finally {
            setAmcLoader(false);
        }
    }

    const getSebiAllocationInvestorLevel = async () => {
        try {
            setIsloading(true);
            const sebiAllocationRes = await (dispatch(getSebiAssetAllocation({
                rmId: `${investorRmId}`,
                clientCode: clientCode,
                // portfolioId: selectedPortfolio?.value,
                portfolioId: urlPortfolio,
                assetGroup: "MF"
            })) as unknown as Promise<SebiAssetAllocationRes>)
            setSebiAllocationData({ ...sebiAllocationRes, result: { ...sebiAllocationRes?.result } })
        } catch (e) {
            console.log("Error", e)
        } finally {
            setIsloading(false);
        }
    }

    const getPortfolioExposure = async () => {
        try {
            setPortfolioLoader(true);
            const portfolioExposurePayload = {
                clientCode: clientCode,
                filter: portfolioFilter === 1 ? "Sectors" : "Companies",
                rmId: `${investorRmId}`,
                category: '',
                // portfolioId: selectedPortfolio?.value,
                portfolioId: urlPortfolio,
                assetGroup: "MF"
            }
            const portfolioAllocationRes = await (dispatch(portfolioExposureInCategory(portfolioExposurePayload)) as unknown as Promise<PortfolioExposureMFRes>);
            setPortfolioExposureData({ ...portfolioAllocationRes, result: { ...portfolioAllocationRes?.result } })
        } catch (e) {
            console.log("Error", e)
        } finally {
            setPortfolioLoader(false)
        }
    }

    const getPerformanceNavChart = async () => {
        try {
            setPerformanceNavLoader(true);
            const performancePayload = {
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                // portfolioId: selectedPortfolio?.value,
                portfolioId: urlPortfolio,
                assetGroup: "MF"
            }
            const performanceNavChartRes = await (dispatch(performanceNavChart(performancePayload)) as unknown as Promise<PerformanceNavChartRes>);
            setPerformanceNavData(performanceNavChartRes)
        } catch (e) {
            console.log("Error", e)
        } finally {
            setPerformanceNavLoader(false)
        }
    }

    const handleCategoryTableSorting = async (orderBy: string, order: Order) => {
        setSortingObj({ orderBy, order })
        categoryWiseInvestorLevel(orderBy, order)
    }
    const handleamcTableSorting = async (orderBy: string, order: Order) => {
        setAMCSortingObj({ orderBy, order })
        amcPerformanceInvestorLevel(orderBy, order)
    }

    useEffect(() => {
        categoryWiseInvestorLevel();
        amcPerformanceInvestorLevel();
        getSebiAllocationInvestorLevel();
        getPerformanceNavChart();
    }, [])
    useEffect(() => {
        getPortfolioExposure()
    }, [portfolioFilter])


    const amcDownloadHandler = async () => {
        try {
            setAmcDownloadLoader(true);
            const formatExportedData = [
                {
                    "amcname": "AMC NAME",
                    "marketValue": "MARKET VALUE",
                    "equity": "EQUITY",
                    "debt": "DEBT",
                    "hybrid": "HYBRID",
                    "others": "OTHERS",
                    "investedValue": "INVESTED VALUE",
                    "unRelease": "UNREALISED GAIN/LOSS",
                    "release": "REALISED GAIN/LOSS",
                    "dividend": "DIVIDEND",
                    "irr": "ABSOLUTE RETURN",
                    "holding": "HOLDING"
                },
                ...(amcPerformanceInvestorData.result ?? [])
            ]
            const res = await dispatch(amcPerformanceDownload({ jsonData: formatExportedData, sheetName: "amc" })) as unknown as any;
            reportDownload(res as unknown as Blob, 'amcPerformanceInvestorReport.xlsx');
        } catch (e) {
            console.log("Error", e)
        } finally {
            setAmcDownloadLoader(false);
        }
    }

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item lg={5} md={12} sx={{ width: '100%' }} sm={12}>
                    <Distribution
                        data={categoryWiseData?.result?.categoryWiseDistribution}
                        isLoading={categoryWiseLoading || loading}
                        clientCode={clientCode ?? ""}
                        completeData={categoryWiseData}
                        urlPortfolio={urlPortfolio}
                        maskedData={maskedData}
                    />
                </Grid>
                <Grid item xs={12} lg={7}>
                    {(!performanceNavLoader && !loading && (!performanceNavData?.isSuccess)) ?
                        <Box sx={{
                            padding: '25px 30px 45px 30px',
                            background: palette.common.white,
                            borderRadius: '20px',
                            height: '100%',
                            width: '100%',
                        }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    height: "100%",
                                    position: "relative"
                                }}
                            >
                                <Typography
                                    variant="h2"
                                    sx={(theme: Theme) => ({
                                        lineHeight: '25px',
                                        letterSpacing: "0.01px",
                                        color: theme.palette.text.primary,
                                        position: "absolute",
                                        top: 0,
                                        left: 0
                                    })}
                                >
                                    Performance
                                </Typography>
                                <Typography
                                    variant="body_600"
                                    sx={(theme: Theme) => ({
                                        fontWeight: 500,
                                        lineHeight: { xs: "18px", sm: "22.5px" }, //60
                                        letterSpacing: "0.01px",
                                        color: theme.palette.text.primary,
                                        textAlign: "center",
                                        width: "100%",
                                        fontSize: { xs: "14px", sm: "16px" },
                                        mt: { xs: 5 }
                                    })}
                                >
                                    {NO_DATA_AVAILABLE}
                                </Typography>

                            </Box>
                        </Box>
                        :
                        <Performance
                            isLoading={performanceNavLoader || loading}
                            getAllData={performanceNavData?.result}
                            maskedData={maskedData}
                        />
                    }
                </Grid>
                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <CategoriesTable
                        title='Category Wise Breakup'
                        tableData={categoryWiseData?.result?.categoryWiseBreakup}
                        isLoading={categoryWiseLoading || loading}
                        clientCode={clientCode}
                        handleTableSorting={handleCategoryTableSorting}
                        sortingObj={sortingObj}
                        setSortingObj={setSortingObj}
                        completeData={categoryWiseData}
                        urlPortfolio={urlPortfolio}
                        maskedData={maskedData}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12} sx={{ width: '100%' }}>
                    <AMCTable
                        title='AMC Performance Analysis'
                        tableData={amcPerformanceInvestorData?.result}
                        isLoading={amcLoader || loading}
                        handleTableSorting={handleamcTableSorting}
                        sortingObj={amcSortingObj}
                        setSortingObj={setAMCSortingObj}
                        amcDownload={amcDownloadHandler}
                        amcDownloadLoader={amcDownloadLoader}
                        completeData={amcPerformanceInvestorData}
                        maskedData={maskedData}
                    />
                </Grid>

                {/* Portfolio Exposure */}
                <Grid item md={12} lg={6} sx={{ mt: { xs: '25px', md: 0 }, width: '100%', }}>
                    <Box sx={(theme: Theme) => ({
                        borderRadius: '20px',
                        padding: '25px 30px 45px 30px',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                        background: theme.palette.common.white,
                        height: '100%'
                    })}>
                        {(!portfolioLoader && !loading && !portfolioExposureData?.isSuccess) ?
                            <Box sx={{ height: '100%' }}>
                                <Typography variant="h2" sx={{ mb: '10%' }} >
                                    Portfolio Exposure
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%"
                                    }}
                                >
                                    <Typography
                                        variant="body_600"
                                        sx={(theme: Theme) => ({
                                            fontWeight: 500,
                                            lineHeight: "22.5px",
                                            letterSpacing: "0.01px",
                                            color: theme.palette.text.primary
                                        })}
                                    >
                                        {NO_DATA_AVAILABLE}
                                    </Typography>
                                </Box>
                            </Box>
                            :
                            <>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Typography variant="h2" sx={{
                                        marginBottom: '40px'
                                    }}>Portfolio Exposure</Typography>
                                    <CustomDropdown setFilterValue={setPortfolioFilter} IsLoading={portfolioLoader} options={[
                                        {
                                            "label": "Sector Allocation",
                                            "value": 1
                                        },
                                        {
                                            "label": "Company Exposure",
                                            "value": 2
                                        }
                                    ]} defaultValue={1} />

                                </Box>
                                {!portfolioLoader && !loading && portfolioExposureData?.result?.data?.length === 0 ? <ErrorText /> :
                                    <CustomePieChart {...{ ...portfolioExposureData?.result, isLoading: portfolioLoader, showSlider: true, title: 'Portfolio Exposure', maskedData }} />
                                }
                            </>
                        }
                    </Box>
                </Grid>

                {/* Sebi allocation Pie chart */}
                <Grid item md={12} lg={6} sx={{ width: '100%' }}>
                    <Box sx={(theme: Theme) => ({
                        borderRadius: '20px',
                        padding: '25px 30px 45px 30px',
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
                        background: theme.palette.common.white,
                        height: '100%'
                    })}
                    >
                        {(!loading && !isLoading && !sebiAllocationData?.isSuccess) ?
                            <Box sx={{ height: '100%' }}>
                                <Typography variant="h2" sx={{ mb: '10%' }} >
                                    Portfolio Exposure
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%"
                                    }}
                                >
                                    <Typography
                                        variant="body_600"
                                        sx={(theme: Theme) => ({
                                            fontWeight: 500,
                                            lineHeight: "22.5px",
                                            letterSpacing: "0.01px",
                                            color: theme.palette.text.primary
                                        })}
                                    >
                                        {NO_DATA_AVAILABLE}
                                    </Typography>
                                </Box>
                            </Box> :
                            <>
                                <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '40px' }}>
                                    <Typography variant="h2" sx={{
                                    }}>Asset Allocation</Typography>

                                    <Typography variant='body_500' sx={(theme: Theme) => (
                                        {
                                            color: theme.palette.primary[500],
                                            borderBottom: `1px dashed ${theme.palette.text.secondary}`
                                        }
                                    )}>SEBI Category</Typography>
                                </Box>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                }}>
                                    {sebiAllocationData?.result?.data?.length === 0 ?
                                        <ErrorText />
                                        : <CustomePieChart {...{ ...sebiAllocationData?.result, isLoading, showSlider: true, maskedData }} />
                                    }

                                    {/* <Box component={'div'} sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        marginTop: '20px',
                                        gap: '30px',
                                        width: { sm: '100%', xs: '100%', md: 'fit-content', lg: 'fit-content' }
                                    }}>
                                        {
                                            (!isLoading || !loading) ?
                                                <>
                                                    {(sebiAllocationData?.result?.labelData?.length > 5 ? sebiAllocationData?.result?.labelData.slice(0, 5) : sebiAllocationData?.result?.labelData)?.map((data, index) => (
                                                        <Box key={index} style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            gap: 15
                                                        }}>
                                                            <CircleIcon style={{ color: pieChartColor[index], width: '11px', height: '11px', }} />
                                                            <Box component={'div'} style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', gap: '15px' }}>
                                                                <Tooltip
                                                                    title={
                                                                        <Typography
                                                                            variant="subtitle_500"
                                                                        >
                                                                            {data.label}
                                                                        </Typography>
                                                                    }
                                                                    followCursor
                                                                >
                                                                    <Typography style={{ textWrap: 'nowrap', color: 'text.primary', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis' }} variant="subtitle_400" >{data.label}</Typography>
                                                                </Tooltip>
                                                                <Typography style={{ textWrap: 'nowrap', color: 'text.primary' }} variant="subtitle_400" align="right">{(Number(data?.value))?.toFixed(2)} %</Typography>
                                                            </Box>
                                                        </Box>
                                                    ))}

                                                    {sebiAllocationData?.result?.labelData?.length > 5 &&
                                                        <Box style={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            alignItems: 'center',
                                                            gap: 15
                                                        }}>
                                                            <CircleIcon style={{ color: pieChartColor[2], width: '11px', height: '11px', }} />
                                                            <Box component={'div'} style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', gap: '15px' }}>
                                                                <Typography style={{ textWrap: 'nowrap', color: 'text.primary', maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis' }} variant="subtitle_400" >Others</Typography>
                                                                <IconButton style={{ padding: '0px', color: 'text.primary' }}>
                                                                    <BlueRightIcon />
                                                                </IconButton>
                                                            </Box>
                                                        </Box>
                                                    }
                                                </>

                                                :

                                                <ChartListSkeletonLoader />}

                                    </Box> */}

                                </Box>

                            </>
                        }


                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default OverView

type CategoriesTableProps = {
    title: string
    tableData: any
    isLoading: boolean
    clientCode?: string
    handleTableSorting: (orderBy: string, order: Order) => void
    sortingObj: SortingObj,
    setSortingObj: ({ order, orderBy }: SortingObj) => void
    amcDownload?: () => void;
    amcDownloadLoader?: boolean;
    completeData?: any;
    urlPortfolio?: string;
    maskedData?: boolean
}

const CategoriesTable = (props: CategoriesTableProps) => {
    const { title, tableData, isLoading, clientCode, handleTableSorting, sortingObj, setSortingObj, completeData, urlPortfolio, maskedData } = props
    const { palette } = useTheme()
    return (
        <Box sx={{
            padding: { xs: '25px 15px 45px 15px', sm: '25px 30px 45px 30px' },
            background: palette.common.white,
            borderRadius: '20px',
            width: '100%',

        }}>
            <Typography variant="h2" color={palette.text.primary} sx={{ fontSize: { xs: '20px', } }}>
                {title}
            </Typography>
            {(!isLoading && !completeData?.isSuccess) ? <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary
                    })}
                >
                    {NO_DATA_AVAILABLE}
                </Typography>
            </Box>
                :
                <Box mt={'20px'}>
                    <CustomTable
                        loadingRowsNum={4}
                        isLoading={isLoading}
                        tableBody={
                            <CategoryTableBody
                                clientCode={clientCode}
                                tableBodyData={tableData || []}
                                handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                                urlPortfolio={urlPortfolio}
                                maskedData={maskedData}
                            />
                        }
                        tableData={tableData || []}
                        tableBodyLoaderRowCustomStyles={{
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        }}
                        tableHeaderData={tableHeaderData}
                        tableHeadRowCustomStyles={{
                            '& th:first-of-type': {
                                paddingLeft: "0px",
                            }
                        }}
                        handleSort={handleTableSorting}
                        tableBodyCustomStyles={{
                            '& tr:last-child td': {
                                border: 0
                            }
                        }}
                        order={sortingObj.order}
                        orderBy={sortingObj.orderBy}
                        tableDataCount={tableData?.length || 0}
                        isPaginationVisible={false}
                        manualResponsiveBody={true}
                        hideResponsiveHeader={true}
                        ManualResponsiveBodyComponent={
                            <CategoryMobileResponsiveBody
                                data={tableData || []}
                                clientCode={clientCode}
                                urlPortfolio={urlPortfolio}
                                maskedData={maskedData}

                            />
                        }
                    />
                </Box>
            }

        </Box>
    )
}
const AMCTable = (props: CategoriesTableProps) => {
    const { title, tableData, isLoading, handleTableSorting, sortingObj, setSortingObj, amcDownload, amcDownloadLoader, completeData, maskedData } = props
    const { palette, typography } = useTheme()
    const [searchInput, setSearchInput] = useState<string>('');
    return (
        <Box sx={{
            padding: { xs: '25px 15px 45px 15px', sm: '25px 30px 45px 30px' },
            background: palette.common.white,
            borderRadius: '20px',
            width: '100%'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexDirection: { xs: 'row', md: 'row' }, alignItems: "center" }}>
                <Typography variant="h2" color={palette.text.primary} sx={{ fontSize: { xs: '19px', } }}>
                    {title}
                </Typography>

                <Tooltip
                    slotProps={{
                        tooltip: {
                            sx: {
                                margin: "0px !important",
                                backgroundColor: "transparent",
                                wordWrap: 'normal'
                            }
                        }
                    }}
                    title={
                        <div
                            style={{
                                borderRadius: '10px', backgroundColor: '#0F131F', padding: '10px'
                            }}
                        >
                            <span style={{ ...typography.subtitle_500, fontFamily: typography.fontFamily }}>Download AMC Performance analysis report</span>
                        </div>
                    }
                >
                    {isLoading ? <></> : (
                        <Box display={'flex'} gap={'10px'} onClick={amcDownload}>
                            <Hidden only={'xs'}>
                                {amcDownloadLoader ? <CircularProgress size={20} /> : (
                                    <Box component={'button'} sx={{ cursor: 'pointer', border: 'none', display: 'flex', gap: '10px', background: 'transparent', alignItems: 'center' }}>
                                        <BlackDownloadIcon />
                                        <Typography color={palette.text.primary} sx={{ ...typography.body_500 }}>Download</Typography>
                                    </Box>
                                )}
                                {/* <TextField
                            // autoFocus
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            sx={{
                                                display: searchInput.length > 0 ? 'inline-flex' : 'none',
                                            }}
                                            onClick={() => setSearchInput('')}
                                        >
                                            <DialogCloseIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                sx: (theme: Theme) => ({
                                    borderRadius: '57px',
                                    height: '47.17px',
                                    border: `1px solid ${theme.palette.text.secondary}B2`,
                                    // marginTop: '20px',
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '& input': {
                                        paddingLeft: '10px',
                                        ...theme.typography.body_500,
                                        color: theme.palette.text.primary,
                                        '::placeholder': {
                                            ...theme.typography.subtitle_400,
                                            color: theme.palette.text.secondary,
                                            opacity: 1,
                                        },
                                    },
                                }),
                            }}
                            placeholder="Search"
                            value={searchInput}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setSearchInput(event.target.value);
                            }}
                        /> */}
                            </Hidden>
                            <Hidden smUp>
                                {amcDownloadLoader ? <CircularProgress size={20} /> : (
                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '6px' }}>
                                        {/* <TextField
                                // autoFocus
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                sx={{
                                                    display: searchInput.length > 0 ? 'inline-flex' : 'none',
                                                }}
                                                onClick={() => setSearchInput('')}
                                            >
                                                <DialogCloseIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    sx: (theme: Theme) => ({
                                        borderRadius: '57px',
                                        height: '47.17px',
                                        border: `1px solid ${theme.palette.text.secondary}B2`,
                                        // marginTop: '20px',
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '& input': {
                                            paddingLeft: '10px',
                                            ...theme.typography.body_500,
                                            color: theme.palette.text.primary,
                                            '::placeholder': {
                                                ...theme.typography.subtitle_400,
                                                color: theme.palette.text.secondary,
                                                opacity: 1,
                                            },
                                        },
                                    }),
                                }}
                                placeholder="Search"
                                value={searchInput}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    setSearchInput(event.target.value);
                                }}
                            /> */}
                                        <CircleDownloadIcon />
                                    </Box>
                                )}
                            </Hidden>
                        </Box>
                    )}
                </Tooltip>
            </Box>

            {(!isLoading && !completeData?.isSuccess) ? <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary
                    })}
                >
                    {NO_DATA_AVAILABLE}
                </Typography>
            </Box>
                :
                <Box mt={'20px'} width={'100%'}>
                    <CustomTable
                        loadingRowsNum={5}
                        isLoading={isLoading}
                        tableBody={
                            <AmcTableBody
                                tableBodyData={tableData || []}
                                handleCheckboxClick={(id: number) => console.log("Checkbox clicked", id)}
                                maskedData={maskedData}
                            />
                        }
                        tableData={tableData || []}
                        tableBodyLoaderRowCustomStyles={{
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        }}
                        tableHeaderData={AmctableHeaderData}
                        tableHeadRowCustomStyles={{
                            '& th:first-of-type': {
                                paddingLeft: "0px"
                            }
                        }}
                        handleSort={handleTableSorting}
                        order={sortingObj.order}
                        orderBy={sortingObj.orderBy}
                        tableBodyCustomStyles={{
                            '& tr:last-child td': {
                                border: 0
                            }
                        }}
                        tableDataCount={tableData?.length || 0}
                        isPaginationVisible={false}
                        manualResponsiveBody={true}
                        hideResponsiveHeader={true}
                        ManualResponsiveBodyComponent={
                            <MobileResponsiveBody
                                // selectedHeaderKey={sortingObj.orderBy}
                                data={tableData || []}
                                maskedData={maskedData}

                            />
                        }
                    />
                </Box>
            }
        </Box >
    )
}

type PortfolioProps = {
    isLoading: boolean
    getAllData?: PortFolioExpore
    title: string
}

type AssetAllocationInvestorProps = {
    isLoading: boolean
    getAllData?: PortFolioExpore
    title: string
}



export const PortfolioExpore = (props: PortfolioProps) => {
    const { isLoading, getAllData, title } = props
    const { palette } = useTheme()
    const [filterValue, setFilterValue] = useState<string | number>(getAllData?.filterOption[0].value as number)
    const [currentData, setCurrentData] = useState<MultipleChart>()

    useEffect(() => {
        if (getAllData) {
            setFilterValue(getAllData?.filterOption[0].value as number)
            setCurrentData({ ...getAllData?.data[0] })
        }
    }, [getAllData])


    useEffect(() => {
        if (filterValue) {
            setCurrentData({ ...getAllData?.data.filter((data) => data.sectionId === filterValue)[0] } as MultipleChart)
        }
    }, [filterValue])

    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px',
            width: '100%'
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h2" color={palette.text.primary}>
                    {title}
                </Typography>
                <Box sx={{ marginBottom: "0.9rem" }}>
                    <CustomDropdown
                        IsLoading={isLoading}
                        options={getAllData?.filterOption as Array<filterType>}
                        defaultValue={getAllData?.filterOption[0].value as number}
                        setFilterValue={setFilterValue}
                    />
                </Box>

            </Box>
            <Box sx={{ display: 'flex', marginTop: '20px', flexDirection: { xs: 'column', md: 'row' } }}>
                <Box width={{ xs: '100%', md: '50%' }}>

                    <CustomePieChart
                        data={currentData?.data as Array<any>}
                        isLoading={isLoading}
                        labelData={currentData?.labelData as Array<filterType>}
                        totalValue={currentData?.totalValue as filterType}
                        showSlider={false}
                        defaultValue={currentData?.totalValue as filterType}
                    />
                </Box>
                <Box sx={{ display: 'flex', width: { xs: '100%', md: '50%' } }}>

                    <Box display={'flex'} flexDirection={'column'} gap={'25px'} justifyContent={'center'} width={'100%'}>

                        {currentData?.labelData?.map((data, index) => {
                            return (
                                <Box key={index} component={'div'} style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100%',
                                    gap: 15
                                }}>
                                    <CircleIcon style={{ color: pieChartColor[index], width: '11px', height: '11px', }} />
                                    <Box component={'div'} style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
                                        <Typography style={{ textWrap: 'nowrap', color: 'text.primary', width: '140px' }} variant="subtitle_400" >{data.label}</Typography>
                                        <Typography style={{ textWrap: 'nowrap', color: 'text.primary' }} variant="subtitle_400" align="right">{data.value}%</Typography>
                                    </Box>
                                </Box>
                            )
                        })}
                        {currentData?.otherData &&
                            <Box component={'div'} style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                gap: 15,
                                borderBottom: `.5px solid ${palette.text.secondary}b2`
                            }}>
                                <CircleIcon style={{ color: pieChartColor[pieChartColor.length - 1], width: '11px', height: '11px', }} />
                                <Box component={'div'} style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography style={{ textWrap: 'nowrap', color: 'text.primary', width: '140px' }} variant="subtitle_400" >Other Sector</Typography>
                                    <IconButton aria-label="View other sectors" onClick={() => console.log('for navigation')}>
                                        <BlueRightIcon />
                                    </IconButton>
                                </Box>
                            </Box>
                        }
                        {isLoading && [...Array(currentData?.otherData ? 6 : 5)].map((data, index) => (
                            <Skeleton key={index} animation="wave" variant="text" width="100%" />
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}



interface DistributionProps {
    isLoading: boolean
    data: DistributorType
    clientCode: string
    completeData: CategoryWiseDistibutionRes;
    urlPortfolio: string;
    maskedData?: boolean;
}
export const Distribution = (props: DistributionProps) => {
    const { isLoading, data, clientCode, completeData, urlPortfolio, maskedData } = props;
    // console.log('dataaa', completeData)
    const { palette } = useTheme()
    const history = useHistory()

    const handleNavigation = (category: string | undefined) => {
        history.push(`${history.location.pathname}/category-wise-breakup?portfolio=${urlPortfolio ?? ""}`, { category, clientCode })
    }

    const pieChartLegends = data?.data.map(([currentLabel, noOfSchemes]) => {
        const labelObj = data?.labelData.find(item => item.label === currentLabel);
        return {
            label: `${currentLabel}`,
            noOfSchemes: Number(noOfSchemes),
            value: labelObj ? labelObj.value : ""
        };
    });

    const pieChartData = data?.data.map(([currentLabel, noOfSchemes, value]) => {
        const labelObj = data?.labelData.find(item => item.label === currentLabel);
        return [currentLabel, value];
    });

    return (
        <Box sx={{
            padding: '25px 30px 45px 30px',
            background: palette.common.white,
            borderRadius: '20px',
            height: '100%',
            width: '100%'
        }}>
            <Typography variant="h2" color={palette.text.primary}>
                Category Wise Distribution
            </Typography>
            {(!isLoading && !completeData?.isSuccess) && <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%"
                }}
            >
                <Typography
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        fontWeight: 500,
                        lineHeight: "22.5px",
                        letterSpacing: "0.01px",
                        color: theme.palette.text.primary
                    })}
                >
                    {NO_DATA_AVAILABLE}
                </Typography>
            </Box>
            }
            {!isLoading && completeData?.isSuccess && (completeData?.result?.categoryWiseDistribution?.data?.length === 0) ?
                <ErrorText />
                :
                <>
                    <CustomePieChart
                        data={pieChartData}
                        isLoading={isLoading}
                        labelData={data?.labelData}
                        totalValue={data?.totalValue as filterType}
                        showSlider={false}
                        align='center'
                        maskedData={maskedData}
                    />
                    <Box display={'flex'} flexDirection={'column'} gap={'25px'}>
                        {!isLoading && pieChartLegends?.map((item, index) => (
                            <Grid
                                key={`${item.label} - ${index}`}
                                container
                                sx={{ alignItems: "center" }}
                                columnSpacing={1}
                            >
                                <Grid
                                    xs={3}
                                    item
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '15px'
                                        }}
                                    >
                                        <CircleIcon
                                            style={{
                                                color: pieChartColor[index],
                                                width: '11px',
                                                height: '11px',
                                            }}
                                        />
                                        <Typography
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.primary,
                                                lineHeight: "20px"
                                            })}
                                            variant="subtitle_400"
                                        >
                                            {item.label}
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid
                                    xs={6}
                                    item
                                >
                                    <Typography
                                        sx={(theme: Theme) => ({
                                            lineHeight: "17.5px",
                                            color: theme.palette.text.secondary
                                        })}
                                        variant="subtitle_500"
                                    >
                                        {`${item?.noOfSchemes} Scheme${item?.noOfSchemes > 1 ? 's' : ''}`}
                                    </Typography>
                                </Grid>
                                <Grid
                                    xs={3}
                                    item
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '15px'
                                        }}>
                                        <Typography
                                            sx={(theme: Theme) => ({
                                                lineHeight: "20px",
                                                color: theme.palette.text.primary
                                            })}
                                            variant="subtitle_400"
                                            align="right"
                                        >
                                            {(maskedData ? '****' : (Number(item?.value))?.toFixed(2) + '%')}
                                        </Typography>

                                        <IconButton
                                            aria-label={`View ${item?.label} details`}
                                            onClick={() => handleNavigation(item?.label)}
                                            sx={{
                                                visibility: item?.label?.toLowerCase() === "others" ? "hidden" : "visible"
                                            }}
                                        >
                                            <BlackRightArrowIcons />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            </Grid>
                        ))}
                        {isLoading && [...Array(5)].map((_, index) => (
                            <Skeleton key={index} animation="wave" variant="text" width="100%" />
                        ))}
                    </Box>
                </>
            }

        </Box>
    )
}

// Custom Mobile Responsive Body Component for AMCTable
// function MobileResponsiveBody({ selectedHeaderKey, data }: { selectedHeaderKey: string, data: any[] }): JSX.Element {
//     const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

//     function calculatePercentage(x: string | number, y: string | number): string {
//         x = Number(x);
//         y = Number(y);

//         if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
//             return "-";
//         }

//         return `${Math.floor((x / y) * 100)}%`;
//     }

//     const getFormattedValue = (item: any, key: string) => {
//         switch (key) {
//             case 'holding':
//                 return item?.holding ? `${(item?.holding).toFixed(2)}%` : "-";
//             case 'equity':
//                 return item?.equity ? `${(item?.equity).toFixed(2)}%` : "-";
//             case 'debt':
//                 return item?.debt ? `${(item?.debt).toFixed(2)}%` : "-";
//             case 'hybrid':
//                 return item?.hybrid ? `${(item?.hybrid).toFixed(2)}%` : "-";
//             case 'investedValue':
//                 return item?.investedValue < 0 ?
//                     `- ${formatCurrency({ value: Math.abs(item?.investedValue), locale, currencyCode })}` :
//                     `${formatCurrency({ value: item?.investedValue, locale, currencyCode })}`;
//             case 'marketValue':
//                 return item?.marketValue < 0 ?
//                     `- ${formatCurrency({ value: Math.abs(item?.marketValue), locale, currencyCode })}` :
//                     `${formatCurrency({ value: item?.marketValue, locale, currencyCode })}`;
//             case 'unRelease': {
//                 const unRealisedGainLossPerc = calculatePercentage(item?.unRelease, item?.investedValue);
//                 return `${item.unRelease < 0 ? "-" : ""}${formatCurrency({
//                     value: Math.abs(item.unRelease),
//                     locale,
//                     currencyCode,
//                 })} (${unRealisedGainLossPerc})`;
//             }
//             case 'irr':
//                 return item?.irr ? `${(item?.irr).toFixed(2)}%` : "-";
//             default:
//                 return item?.[key] ?? "-";
//         }
//     };

//     return (
//         <>
//             {data.map((item: any, index: number) => (
//                 <TableRow key={index}>
//                     <TableCell align="left">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 '&:hover': {
//                                     color: theme.palette.primary[500],
//                                 },
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {item?.amcname}
//                         </Typography>
//                     </TableCell>
//                     <TableCell align="center">
//                         <Typography
//                             variant="body_500"
//                             sx={(theme: Theme) => ({
//                                 color: theme.palette.text.primary,
//                                 fontSize: '16px',
//                             })}
//                         >
//                             {getFormattedValue(item, selectedHeaderKey)}
//                         </Typography>
//                     </TableCell>
//                 </TableRow>
//             ))}
//         </>
//     );
// }

function MobileResponsiveBody({
    data,
    maskedData,

}: {
    data: any[];
    maskedData?: boolean;

}): JSX.Element {
    const { locale, currencyCode } = useSelector(
        (store: RootStateType) => store.currencyInfo
    );

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }

    const getFormattedValue = (
        item: any,
        key: string
    ): { value: string } => {
        if (maskedData) {
            return { value: "***" };
        }

        switch (key) {
            case "holding":
                return { value: item?.holding ? `${(item?.holding).toFixed(2)}%` : "-" };

            case "equity":
                return { value: item?.equity ? `${(item?.equity).toFixed(2)}%` : "-" };

            case "debt":
                return { value: item?.debt ? `${(item?.debt).toFixed(2)}%` : "-" };

            case "hybrid":
                return { value: item?.hybrid ? `${(item?.hybrid).toFixed(2)}%` : "-" };

            case "investedValue":
                return {
                    value:
                        item?.investedValue < 0
                            ? `- ${formatCurrency({
                                value: Math.abs(item?.investedValue),
                                locale,
                                currencyCode,
                            })}`
                            : `${formatCurrency({
                                value: item?.investedValue,
                                locale,
                                currencyCode,
                            })}`,
                };

            case "marketValue":
                return {
                    value:
                        item?.marketValue < 0
                            ? `- ${formatCurrency({
                                value: Math.abs(item?.marketValue),
                                locale,
                                currencyCode,
                            })}`
                            : `${formatCurrency({
                                value: item?.marketValue,
                                locale,
                                currencyCode,
                            })}`,
                };

            case "unRelease": {
                const unRealisedGainLossPerc = calculatePercentage(
                    item?.unRelease,
                    item?.investedValue
                );
                return {
                    value: `${item.unRelease < 0 ? "-" : ""}${formatCurrency({
                        value: Math.abs(item.unRelease),
                        locale,
                        currencyCode,
                    })} (${unRealisedGainLossPerc})`,
                };
            }

            case "irr":
                return {
                    value: item?.irr ? `${(item?.irr).toFixed(2)}%` : "-",
                };

            default:
                return { value: item?.[key] ?? "-" };
        }
    };

    return (
        <Box display="flex" flexDirection="column" gap={2}>
            {data.map((item, index) => (
                <Box
                    key={`${item?.amcname ?? ""}-${index}`}
                    sx={(theme: Theme) => ({
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: "12px",
                        padding: "12px",
                        backgroundColor: theme.palette.background.paper,
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                            borderColor: theme.palette.primary[500],
                            boxShadow: theme.shadows[2],
                        },
                    })}
                >
                    {/* AMC NAME */}
                    <Typography
                        variant="body_600"
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.primary,
                            fontSize: "16px",
                            marginBottom: "8px",
                        })}
                    >
                        {getFormattedValue(item, "amcname").value}
                    </Typography>

                    {/* Label-Value Rows */}
                    <Box display="flex" flexDirection="column" gap={1.5}>
                        {AmctableHeaderData.filter((header) => header.id !== "amcname").map(
                            (header) => {
                                const { value } = getFormattedValue(item, header.id);

                                return (
                                    <Box
                                        key={header.id}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        {/* Label on left */}
                                        <Typography
                                            variant="overline"
                                            sx={(theme: Theme) => ({
                                                color: theme.palette.text.secondary,
                                                fontSize: "13px",
                                                lineHeight: "16px",
                                            })}
                                        >
                                            {header.label}
                                        </Typography>

                                        {/* Value on right */}
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                color: getValueColor(header.id, Number(item?.[header.id as keyof AMCPerformanceProductsRes] ?? 0), theme, Boolean(maskedData)),
                                                fontWeight: 500,
                                                textAlign: "right",
                                            })}
                                        >
                                            {value}
                                        </Typography>
                                    </Box>
                                );
                            }
                        )}
                    </Box>
                </Box>
            ))}
        </Box>
    );
}



export const CategoryMobileResponsiveBody = ({
    data,
    clientCode,
    urlPortfolio = "",
    maskedData = false,

}: any): JSX.Element => {
    const theme = useTheme();
    const history = useHistory();
    const pathName = history?.location?.pathname;
    const initialRouter = pathName.split("/").filter((item) => item !== "");
    const isProductInPathName =
        `${initialRouter[0] ?? ""}`.toLowerCase() === "product";

    const { locale, currencyCode } = useSelector(
        (store: RootStateType) => store.currencyInfo
    );

    const handleArrowClick = (category: string) => {
        history.push(
            `${pathName}/category-wise-breakup${!isProductInPathName ? `?portfolio=${urlPortfolio ?? ""}` : ""
            }`,
            { category, clientCode }
        );
    };

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }



    return (
        <Box display="flex" flexDirection="column" gap="16px" mt="10px">
            {data?.map((obj: any, i: number) => {
                const realisedGainLossPerc = calculatePercentage(
                    obj?.release,
                    obj?.investedValue
                );
                const unRealisedGainLossPerc = calculatePercentage(
                    obj?.unRelease,
                    obj?.investedValue
                );

                return (
                    <Box
                        key={i}
                        sx={{
                            border: `1px solid ${theme.palette.grey[300]}`,
                            borderRadius: "12px",
                            padding: "9px",
                            backgroundColor: theme.palette.common.white,
                        }}
                    >
                        {/* Category Name as heading */}
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme.palette.text.primary,
                                fontWeight: 600,
                                marginBottom: "12px",
                            }}
                        >
                            {obj?.categoryType}
                        </Typography>

                        {/* Loop over headers except categoryType */}
                        {tableHeaderData
                            .filter((header) => header.id !== "categoryType")
                            .map((header, idx) => {
                                let value: React.ReactNode = null;

                                switch (header.id) {
                                    case "investedValue":
                                        value = maskedData
                                            ? "***"
                                            : formatCurrency({
                                                value: obj?.investedValue,
                                                locale,
                                                currencyCode,
                                            });
                                        break;

                                    case "marketValue":
                                        value = maskedData
                                            ? "***"
                                            : formatCurrency({
                                                value: obj?.marketValue,
                                                locale,
                                                currencyCode,
                                            });
                                        break;

                                    case "release":
                                        value = maskedData
                                            ? "***"
                                            : `${obj.release < 0 ? "-" : ""}${formatCurrency(
                                                {
                                                    value: Math.abs(obj.release),
                                                    locale,
                                                    currencyCode,
                                                }
                                            )} (${realisedGainLossPerc})`;
                                        break;

                                    case "dividend":
                                        value = maskedData ? "***" : obj?.dividend;
                                        break;

                                    case "unRelease":
                                        value = maskedData
                                            ? "***"
                                            : `${obj.unRelease < 0 ? "-" : ""}${formatCurrency(
                                                {
                                                    value: Math.abs(obj.unRelease),
                                                    locale,
                                                    currencyCode,
                                                }
                                            )} (${unRealisedGainLossPerc})`;
                                        break;

                                    case "irr":
                                        value = maskedData
                                            ? "***"
                                            : obj?.irr &&
                                            (obj?.irr).toFixed(2) + "%";
                                        break;

                                    case "ACTIONS":
                                        value =
                                            obj?.categoryType !== "Others" ? (
                                                <IconButton
                                                    aria-label={`View ${obj?.categoryType} details`}
                                                    onClick={() =>
                                                        handleArrowClick(
                                                            obj?.categoryType
                                                        )
                                                    }
                                                >
                                                    <BlackRightArrowIcons />
                                                </IconButton>
                                            ) : null;
                                        break;

                                    default:
                                        value = obj?.[header.id] ?? "-";
                                        break;
                                }

                                return (
                                    <Box
                                        key={idx}
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "8px 0",
                                            borderBottom:
                                                idx !==
                                                    tableHeaderData.length - 2
                                                    ? `1px solid ${theme.palette.grey[200]}`
                                                    : "none",
                                        }}
                                    >
                                        <Typography
                                            variant="body_500"
                                            sx={{
                                                color: theme.palette.text.secondary,
                                            }}
                                        >
                                            {header.label}
                                        </Typography>
                                        <Typography
                                            variant="body_500"
                                            sx={{
                                                color: getValueColor(header.id, Number(obj?.[header.id as keyof CategoryWiseDistibutionRes] ?? 0), theme, Boolean(maskedData)),
                                                fontWeight: 500,
                                            }}
                                        >
                                            {value}
                                        </Typography>
                                    </Box>
                                );
                            })}
                    </Box>
                );
            })}
        </Box>
    );
};

export const SystematicPlanTableMobileResponsiveBody = ({
    data,
    clientCode,
    urlPortfolio = "",
    maskedData = false
}: any): JSX.Element => {
    const theme = useTheme();
    const history = useHistory();
    const pathName = history?.location?.pathname;
    const initialRouter = pathName.split("/").filter((item) => item !== "");
    const isProductInPathName =
        `${initialRouter[0] ?? ""}`.toLowerCase() === "product";

    const { locale, currencyCode } = useSelector(
        (store: RootStateType) => store.currencyInfo
    );

    const handleArrowClick = (schemeName: string) => {
        history.push(
            `${pathName}/scheme-details${!isProductInPathName ? `?portfolio=${urlPortfolio ?? ""}` : ""
            }`,
            { schemeName, clientCode }
        );
    };

    function calculatePercentage(x: string | number, y: string | number): string {
        x = Number(x);
        y = Number(y);

        if (!Number.isFinite(x) || !Number.isFinite(y) || y === 0) {
            return "-";
        }

        return `${Math.floor((x / y) * 100)}%`;
    }

    return (
        <Box
            sx={{
                border: `2px solid ${theme.palette.primary.main}`,
                borderRadius: "16px",
                padding: "20px",
                backgroundColor: theme.palette.background.paper,
                boxShadow: theme.shadows[3],
                mt: "10px"
            }}
        >
            {/* Header Section */}
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
                paddingBottom: "12px",
                borderBottom: `2px solid ${theme.palette.primary.light}`
            }}>
                <Typography
                    variant="h5"
                    sx={{
                        color: theme.palette.primary.main,
                        fontWeight: 700,
                        fontSize: { xs: "18px", sm: "20px" }
                    }}
                >
                    Systematic Investment Plans
                </Typography>
                <Typography
                    variant="body_600"
                    sx={{
                        color: theme.palette.text.secondary,
                        fontSize: "14px"
                    }}
                >
                    {data?.length || 0} Active Plans
                </Typography>
            </Box>

            {/* Schemes List */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {data?.map((scheme: any, index: number) => {
                    const realisedGainLossPerc = calculatePercentage(
                        scheme?.realisedGainLoss,
                        scheme?.investedValue
                    );
                    const unRealisedGainLossPerc = calculatePercentage(
                        scheme?.unRealisedGainLoss,
                        scheme?.investedValue
                    );

                    return (
                        <Box
                            key={`${scheme?.schemeName}-${index}`}
                            sx={{
                                border: `1px solid ${theme.palette.grey[200]}`,
                                borderRadius: "12px",
                                padding: "16px",
                                backgroundColor: theme.palette.common.white,
                                transition: "all 0.2s ease-in-out",
                                "&:hover": {
                                    borderColor: theme.palette.primary.main,
                                    boxShadow: theme.shadows[2],
                                    transform: "translateY(-2px)"
                                }
                            }}
                        >
                            {/* Scheme Header */}
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "12px"
                            }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: theme.palette.text.primary,
                                        fontWeight: 600,
                                        fontSize: { xs: "14px", sm: "16px" },
                                        flex: 1,
                                        marginRight: "12px"
                                    }}
                                >
                                    {scheme?.schemeName || "Scheme Name"}
                                </Typography>
                                <IconButton
                                    aria-label={`View ${scheme?.schemeName || "scheme"} details`}
                                    onClick={() => handleArrowClick(scheme?.schemeName)}
                                    sx={{
                                        color: theme.palette.primary.main,
                                        padding: "4px",
                                        "&:hover": {
                                            backgroundColor: theme.palette.primary.light + "20"
                                        }
                                    }}
                                >
                                    <BlackRightArrowIcons />
                                </IconButton>
                            </Box>

                            {/* Scheme Details Grid */}
                            <Box sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(3, 1fr)" },
                                gap: "12px"
                            }}>
                                {/* Invested Value */}
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px"
                                }}>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Invested Value
                                    </Typography>
                                    <Typography
                                        variant="body_600"
                                        sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: "14px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {maskedData ? "***" : formatCurrency({
                                            value: scheme?.investedValue || 0,
                                            locale,
                                            currencyCode,
                                        })}
                                    </Typography>
                                </Box>

                                {/* Market Value */}
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px"
                                }}>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Market Value
                                    </Typography>
                                    <Typography
                                        variant="body_600"
                                        sx={{
                                            color: theme.palette.text.primary,
                                            fontSize: "14px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {maskedData ? "***" : formatCurrency({
                                            value: scheme?.marketValue || 0,
                                            locale,
                                            currencyCode,
                                        })}
                                    </Typography>
                                </Box>

                                {/* Realised Gain/Loss */}
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px"
                                }}>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Realised P&L
                                    </Typography>
                                    <Typography
                                        variant="body_600"
                                        sx={{
                                            color: (scheme?.realisedGainLoss || 0) >= 0
                                                ? theme.palette.success.main
                                                : theme.palette.error.main,
                                            fontSize: "14px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {maskedData ? "***" : `${scheme.realisedGainLoss < 0 ? "-" : ""}${formatCurrency(
                                            {
                                                value: Math.abs(scheme?.realisedGainLoss || 0),
                                                locale,
                                                currencyCode,
                                            }
                                        )} (${realisedGainLossPerc})`}
                                    </Typography>
                                </Box>

                                {/* Unrealised Gain/Loss */}
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px"
                                }}>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Unrealised P&L
                                    </Typography>
                                    <Typography
                                        variant="body_600"
                                        sx={{
                                            color: (scheme?.unRealisedGainLoss || 0) >= 0
                                                ? theme.palette.success.main
                                                : theme.palette.error.main,
                                            fontSize: "14px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {maskedData ? "***" : `${scheme.unRealisedGainLoss < 0 ? "-" : ""}${formatCurrency(
                                            {
                                                value: Math.abs(scheme?.unRealisedGainLoss || 0),
                                                locale,
                                                currencyCode,
                                            }
                                        )} (${unRealisedGainLossPerc})`}
                                    </Typography>
                                </Box>

                                {/* IRR */}
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px"
                                }}>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Absolute Return
                                    </Typography>
                                    <Typography
                                        variant="body_600"
                                        sx={{
                                            color: (scheme?.irr || 0) >= 0
                                                ? theme.palette.success.main
                                                : theme.palette.error.main,
                                            fontSize: "14px",
                                            fontWeight: 600
                                        }}
                                    >
                                        {maskedData ? "***" : scheme?.irr ? `${(scheme?.irr).toFixed(2)}%` : "-"}
                                    </Typography>
                                </Box>

                                {/* Status */}
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px"
                                }}>
                                    <Typography
                                        variant="overline"
                                        sx={{
                                            color: theme.palette.text.secondary,
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            textTransform: "uppercase"
                                        }}
                                    >
                                        Status
                                    </Typography>
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px"
                                    }}>
                                        <Box sx={{
                                            width: "8px",
                                            height: "8px",
                                            borderRadius: "50%",
                                            backgroundColor: theme.palette.success.main
                                        }} />
                                        <Typography
                                            variant="body_500"
                                            sx={{
                                                color: theme.palette.success.main,
                                                fontSize: "14px",
                                                fontWeight: 600
                                            }}
                                        >
                                            Active
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    );
                })}
            </Box>

            {/* Empty State */}
            {(!data || data.length === 0) && (
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "40px 20px",
                    textAlign: "center"
                }}>
                    <Typography
                        variant="h6"
                        sx={{
                            color: theme.palette.text.secondary,
                            marginBottom: "8px"
                        }}
                    >
                        No Systematic Plans Found
                    </Typography>
                    <Typography
                        variant="body_500"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontSize: "14px"
                        }}
                    >
                        Start your systematic investment journey today
                    </Typography>
                </Box>
            )}
        </Box>
    );
};


